export default function OnboardingIndex() {
  return <div>{/* Maybe show non-onboarded transctions here? */}</div>;
}
